import React from 'react';
class HomeAccountManagerInfo extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      ejecutivoInfo: {
        avatar: '',
        name: ''
      },
      error: null
    };

  }

  componentDidMount() {
  }

  render() {

    return (
      <div className="account-manager-info-container">

        <div className="account-manager-info-form-header">
          <span>Mi ejecutivo de cuenta</span>
        </div>
        {
          <div className="row">

            {this.state.loading ? <div className="account-manager-campo-imagen">
              <div class="spinner"></div>
            </div> :
              (this.state.ejecutivoInfo.avatar) ?
                <img className="account-manager-campo-imagen" alt="foto avatar" src={this.state.ejecutivoInfo.avatar} />
                : <span className="account-manager-campo-imagen">
                <i class="fas fa-image"></i>
                </span>
            }


            <div className="col-12">
              <div className="row pb-3 pt-4">
                <div className="col-1 account-manager-campo-titulo"><i className="fa fa-user"></i></div>
                <div className="account-manager-campo-valor">{this.state.ejecutivoInfo.name}</div>
              </div>

              {this.state.ejecutivoInfo.telephone &&
                <div className="row pb-3">
                  <div className="col-1 account-manager-campo-titulo"><i className="fa fa-phone"></i></div>
                  <div className="account-manager-campo-valor">{<a target='_blank' rel="noopener noreferrer" href={`https://wa.me/${this.state.ejecutivoInfo.telephone?.replace('+', '').replace('-', '').replace(/ /g, '')}`}>{this.state.ejecutivoInfo.telephone}</a>}</div>
                </div>
              }
              {this.state.ejecutivoInfo.email &&
                <div className="row pb-3">
                  <div className="col-1 account-manager-campo-titulo"><i className="fa fa-envelope"></i></div>
                  <div className="account-manager-campo-valor">{this.state.ejecutivoInfo.email}</div>
                </div>
              }

            </div>
          </div>
        }
        {this.state && this.state.error && !this.state.ejecutivoInfo &&
          <div>
            <div className="row pb-3 pt-4">
              <div className="col-1"></div>
              <div className="col-10 account-manager-campo-error">{this.state.error}</div>
              <div className="col-1"></div>
            </div>
          </div>
        }
      </div>
    );

  }

};

export default HomeAccountManagerInfo;
